import React from 'react';
import PropTypes from 'prop-types';
import { Card, Tab } from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';

import Tabs from 'PointOfSale/modules/cepCard/component/Tabs';
import TotalMeals from 'PointOfSale/modules/cepCard/component/TotalMeals';
import { BulkServeContainer } from 'PointOfSale/modules/cepCard/container';

import 'PointOfSale/styles/components/cepCard.less';

const CEPComponent = ({
  servedMealsCount,
  incrementServe,
  activeTabIndex,
  changeTab,
  lastServedTime,
  offsetMinutes,
}) => {
  const panes = [
    {
      menuItem: 'Total meals served',
      render: () => (
        <Tab.Pane attached={true} className="cep-tab-segment">
          <TotalMeals count={servedMealsCount} onClickServe={incrementServe} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Bulk Serve',
      render: () => (
        <Tab.Pane attached={true} className="cep-tab-segment">
          <BulkServeContainer onClickServe={incrementServe} />
        </Tab.Pane>
      ),
    },
  ];

  const time = moment(lastServedTime);

  if (!_.isNil(offsetMinutes)) {
    time.utcOffset(offsetMinutes);
  }

  return (
    <div className="cep-container">
      <Card className="cep-card">
        <Card.Content className="cep-tab-content">
          <Tabs
            panes={panes}
            activeTabIndex={activeTabIndex}
            changeTab={changeTab}
          />

          <div className="lastTimeServed">
            {lastServedTime && (
              <span>
                Last meal served at
                <span className="time">
                  &nbsp;
                  {time.format('LTS')}
                </span>
              </span>
            )}
          </div>
        </Card.Content>
      </Card>
    </div>
  );
};

CEPComponent.propTypes = {
  servedMealsCount: PropTypes.number,
  activeTabIndex: PropTypes.number,
  changeTab: PropTypes.func,
  incrementServe: PropTypes.func,
};

export default CEPComponent;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/cepCard/component/CEPComponent.js